import React from "react";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

function Loader() {
  const loading = useSelector((state) => state.loading.isLoading);
  return (
    <>
      {loading && (
        <div className="loader-wrapper">
          <CircularProgress />
        </div>
      )}
    </>
  );
}

export default Loader;
